import { prettyFloat } from 'utils';
const initial_stroke = {
    stroke_online: { dasharray: '0', dashoffset: '0' },
    stroke_offline: { dasharray: '0', dashoffset: '0' },
    stroke_error: { dasharray: '0', dashoffset: '0' },
};
const one_circle_stroke = { dasharray: '100 100', dashoffset: '0' };
const two_circle_stroke = (counts, sum_count, name1, name2) => {
    return {
        [`stroke_${name1}`]: {
            dasharray: `${prettyFloat((counts[name1] / sum_count) * 100 - 2)} 100`,
            dashoffset: '0',
        },
        [`stroke_${name2}`]: {
            dasharray: `${prettyFloat((counts[name2] / sum_count) * 100 - 2)} 100`,
            dashoffset: `-${prettyFloat((counts[name1] / sum_count) * 100)}`,
        },
    };
};
function calcCircleStroke(counts) {
    const { online, offline, error } = counts;
    const sum_count = (online != null ? online : 0) +
        (offline != null ? offline : 0) +
        (error != null ? error : 0);
    //Если все нулевые
    if (online == null && offline == null && error == null) {
        return initial_stroke;
    }
    //Если только 1 тип есть
    if (online != null && offline == null && error == null) {
        return {
            ...initial_stroke,
            stroke_online: one_circle_stroke,
        };
    }
    if (online == null && offline != null && error == null) {
        return {
            ...initial_stroke,
            stroke_offline: one_circle_stroke,
        };
    }
    if (online == null && offline == null && error != null) {
        return {
            ...initial_stroke,
            stroke_error: one_circle_stroke,
        };
    }
    //Если 2 типа есть
    if (online != null && offline != null && error == null) {
        return {
            ...initial_stroke,
            ...two_circle_stroke(counts, sum_count, 'online', 'offline'),
        };
    }
    if (online != null && offline == null && error != null) {
        return {
            ...initial_stroke,
            ...two_circle_stroke(counts, sum_count, 'online', 'error'),
        };
    }
    if (online == null && offline != null && error != null) {
        return {
            ...initial_stroke,
            ...two_circle_stroke(counts, sum_count, 'offline', 'error'),
        };
    }
    if (online != null && offline != null && error != null) {
        return {
            stroke_online: {
                dasharray: `${prettyFloat((online / sum_count) * 100 - 2)} 100`,
                dashoffset: '0',
            },
            stroke_offline: {
                dasharray: `${prettyFloat((offline / sum_count) * 100 - 2)} 100`,
                dashoffset: `-${prettyFloat((online / sum_count) * 100)}`,
            },
            stroke_error: {
                dasharray: `${prettyFloat((error / sum_count) * 100 - 2)} 100`,
                dashoffset: `-${prettyFloat((offline / sum_count) * 100 + (online / sum_count) * 100)}`,
            },
        };
    }
    return initial_stroke;
}
function createSvg(counts) {
    const { online, offline, error } = counts;
    const { stroke_online, stroke_offline, stroke_error } = calcCircleStroke(counts);
    const content = `
             <defs>
                  <radialGradient id="radialGradient878"> 
                       <stop offset="0" stop-color="#b2ebf2"></stop>
                       <stop stop-opacity="0" offset="1" stop-color="#b2ebf2"></stop>
                  </radialGradient>
             </defs>
              <circle 
              class="back" 
              r="13.7" cx="50%" cy="50%" 
              fill="#2ababe"
              ></circle>
              <circle 
              class="inner" 
              r="10" cx="50%" cy="50%" 
              fill="url(#radialGradient878)"></circle>` +
        (online != null
            ? `<circle 
              class="online"
              stroke="#4caf50" 
              r="15.9" cx="50%" cy="50%" 
              fill="none" 
              stroke-width="3px" 
              stroke-dasharray="${stroke_online.dasharray}"
              stroke-dashoffset="${stroke_online.dashoffset}"
              ></circle>`
            : '') +
        (offline != null
            ? `<circle 
              class="offline"
              stroke="#a9a9a9"  
              r="15.9" cx="50%" cy="50%" 
              fill="none" 
              stroke-width="3px" 
              stroke-dasharray="${stroke_offline.dasharray}" 
              stroke-dashoffset="${stroke_offline.dashoffset}"
              ></circle>`
            : '') +
        (error != null
            ? ` 
              <circle 
              class="error" 
              stroke="#c4443b" 
              r="15.9" cx="50%" cy="50%" 
              fill="none" 
              stroke-width="3px" 
              stroke-dasharray="${stroke_error.dasharray}" 
              stroke-dashoffset="${stroke_error.dashoffset}"
              ></circle>`
            : '');
    const svg = document.createElement('svg');
    svg.setAttribute('width', '80');
    svg.setAttribute('height', '80');
    svg.setAttribute('viewBox', '0 0 35 35');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.innerHTML = content;
    return svg.outerHTML;
}
function createInfo(counts) {
    const { online, offline, error } = counts;
    const content = (offline != null
        ? `<li class="offline" title="не в сети">${offline}</li>`
        : '') +
        (error != null ? `<li class="error" title="есть ошибки">${error}</li>` : '') +
        (online != null ? `<li class="online" title="в сети">${online}</li>` : '');
    const ul = document.createElement('ul');
    ul.setAttribute('class', 'info');
    ul.innerHTML = content;
    return ul.outerHTML;
}
function getClusterCount(points) {
    let online_count = null;
    let offline_count = null;
    let error_count = null;
    points.forEach((point) => {
        const { errors, online } = point.properties;
        if (errors != null) {
            error_count = error_count != null ? error_count + 1 : 1;
        }
        else {
            if (online) {
                online_count = online_count != null ? online_count + 1 : 1;
            }
            else {
                offline_count = offline_count != null ? offline_count + 1 : 1;
            }
        }
    });
    return { online: online_count, offline: offline_count, error: error_count };
}
export function getMarkerIcon(point) {
    const counts = getClusterCount(point);
    const content = createInfo(counts) + createSvg(counts);
    const div = document.createElement('div');
    div.setAttribute('class', 'cluster-canvas container');
    div.innerHTML = content;
    return div.outerHTML;
}
